import type { SolutionsContent } from "../content/solutions";
import { Editable } from "../edit";
import { CtaBandSection, PageHero, SectionHead, SpecBlock } from "./common";

export function SolutionsSections({ content }: { content: SolutionsContent }) {
  const c = content;
  return (
    <>
      <PageHero path="hero" eyebrow={c.hero.eyebrow} heading={c.hero.heading} lede={c.hero.lede} />

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap">
          {c.specs.map((spec, i) => (
            <SpecBlock spec={spec} path={`specs.${i}`} key={i} />
          ))}
        </div>
      </section>

      <hr className="divider" />

      <section className="section">
        <div className="wrap">
          <SectionHead
            path="industries"
            eyebrow={c.industries.eyebrow}
            heading={c.industries.heading}
            lede={c.industries.lede}
          />
          <div className="industries">
            {c.industries.tags.map((tag, i) => (
              <Editable as="span" key={i} path={`industries.tags.${i}`} value={tag} />
            ))}
          </div>
        </div>
      </section>

      <CtaBandSection path="ctaBand" content={c.ctaBand} />
    </>
  );
}
